import { XImage } from "IZOX/_X";

function FPSQR(){

  return (
    <XImage width={150} height={150} source={"/Images/fpsqr.png"}/>
  );

}

export default FPSQR;